import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import AssessPopupBox from "../Three_Dot_Popup_Box/AssessPopupBox";
import "./publishAssessBoxPreRead.css";
import moment from "moment";
import axios from "../../../../../axios";
import NoResponse from "../../../Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import { Tooltip } from "@mui/material";
import { BookText, CalendarDays, MoreVertical } from "lucide-react";
import PublishedQListPreRead from "../Published_Q_list/PublishedQListPreRead";

const PublishAssessBoxPreRead = ({ filter }) => {
  // console.log(filter);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [publishedCard, setPublishedCard] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const [isGettingData, setIsGettingData] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isDeactivated, setIsDeactivated] = useState(false);
  const [deactivatePopupId, setDeactivatePopupId] = useState(null);

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  function convertToISO(dateString) {
    const date = new Date(dateString);
    const isoDate = date.toISOString();
    return isoDate;
  }

  useEffect(() => {
    const publishedBox = async () => {
      try {
        let response = await axios.get(
          `/api/v1/homework/preRead/filterByTeacherId/${Teacher_Json}/published?_page=1&academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.date && `date=${convertToISO(filter?.date)}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data.data.length === 0) {
          setNoresponse(true);
        }
        console.log(response.data.data);
        setPublishedCard(response.data.data);
      } catch (e) {
        console.log(e);
      } finally {
        setIsGettingData(false);
      }
    };
    publishedBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, isDeactivated]);

  console.log(publishedCard, "publishedCard");

  function shortenParagraph(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + "...";
  }

  return publishedCard && publishedCard.length > 0 ? (
    <>
      <div className="container">
        <div className="row">
          {publishedCard.map((publicData, idx) => (
            // <PublishAssessBoxPreRead publicData={publicData} />
            <div
              key={idx}
              className="col-md-3 d-flex mb-3"
              style={{ cursor: "pointer" }}
            >
              <div
                className="w-100 h-100 d-flex flex-column py-2 px-3 text-start shadow-sm rounded-4"
                style={{
                  backgroundColor: "#FDEFE3",
                  borderTop: "2px solid #8D4B28",
                  borderRight: "4px solid #8D4B28",
                  borderBottom: "1px solid #8D4B28",
                  borderLeft: "1px solid #8D4B28",
                  borderRadius: "0.75rem",
                }}
              >
                <div className="d-flex justify-content-between align-items-start mb-2">
                  {/* <NavLink
                    to="/PublishedQListPreRead"
                    className="text-dark fw-semibold text-decoration-none"
                    state={{ publishPre_id: publicData?.id }}
                  > */}
                  <span>
                    {`${publicData?.standard_id?.name} - ${publicData?.section_id?.name} | `}
                    <span
                      title={publicData?.subject_id?.name}
                      className="poppins-semibold"
                    >
                      {shortenParagraph(publicData?.subject_id?.name, 30)}
                    </span>
                  </span>
                  {/* </NavLink> */}

                  <Popup
                    trigger={
                      <MoreVertical size={18} style={{ cursor: "pointer" }} />
                    }
                    open={deactivatePopupId === publicData?.id}
                    onClose={() => setDeactivatePopupId(null)}
                    onOpen={() => setDeactivatePopupId(publicData?.id)}
                    content={
                      <div className="open_publish_pre_popupBox">
                        <AssessPopupBox
                          publicPreRead_id={publicData?.id}
                          setIsDeactivated={setIsDeactivated}
                          setDeactivatePopup={() => setDeactivatePopupId(null)}
                        />
                      </div>
                    }
                    on="click"
                    hideOnScroll
                    position="bottom right"
                  />
                </div>

                <div
                  onClick={() => {
                    setSelectedId(publicData?.id);
                    setIsPopupOpen(true);
                  }}
                >
                  <div className="d-flex align-items-center mb-1">
                    <BookText size={16} className="me-2 text-dark" />
                    <div
                      className="text-truncate poppins-semibold"
                      title={publicData?.name}
                    >
                      {shortenParagraph(publicData?.name, 25)}
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center text-muted"
                    style={{ fontSize: "0.875rem" }}
                  >
                    <CalendarDays size={16} className="me-2 text-dark" />
                    <span className="me-1">Deadline:</span>
                    <span className="text-dark">
                      {moment(publicData?.deadline).calendar(null, {
                        sameDay: "[Today] ",
                        nextDay: "[Tomorrow]",
                        nextWeek: "DD/MM/YYYY",
                        lastDay: "DD/MM/YYYY",
                        lastWeek: "DD/MM/YYYY",
                        sameElse: "DD/MM/YYYY",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {isPopupOpen && selectedId && (
        <PublishedQListPreRead
          publishPre_id={selectedId}
          onClose={() => {
            setIsPopupOpen(false);
            setSelectedId(null);
          }}
        />
      )}

      {/* ) : (
        <span className="text-center no_post_yet">
          No posts yet. Be the first one to add a post to community
        </span>
      ) */}
      {/* {noresponse && <NoResponse setNoresponse={setNoresponse} />} */}
    </>
  ) : // (
  //   <>
  //     <img
  //       className="publishAccessLoader"
  //       src="/gift/black loader.gif"
  //       alt=""
  //     />

  //     {noresponse && <NoResponse setNoresponse={setNoresponse} />}
  //   </>
  // );
  isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="badge bg-light text-dark  rounded-pill px-4 py-3"
        style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
      >
        📭 Pre-Read Not Found
      </span>
    </div>
  );
};

export default PublishAssessBoxPreRead;
